import { motion, Variants, Transition } from "motion/react";

const variants: Variants = {
  start: { opacity: 0.5 },
  end: { opacity: 1 },
};

const ellipsisStyle: React.CSSProperties = {
  width: 3,
  height: 3,
  marginBottom: 4,
  borderRadius: "100vw",
};

const transitionConfig: Transition = {
  repeat: Infinity,
  ease: "easeInOut",
  repeatType: "reverse",
};

const ellipsisContainerStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "start",
  gap: 3,
  height: "100%",
  alignSelf: "end",
};

export function Ellipsis(props: { color?: string }) {
  return (
    <motion.div style={ellipsisContainerStyle}>
      <motion.div
        style={{ ...ellipsisStyle, backgroundColor: props.color ?? "white" }}
        variants={variants}
        initial="start"
        animate="end"
        transition={transitionConfig}
      />
      <motion.div
        style={{ ...ellipsisStyle, backgroundColor: props.color ?? "white" }}
        variants={variants}
        initial="start"
        animate="end"
        transition={{
          ...transitionConfig,
          delay: 0.1,
        }}
      />
      <motion.div
        style={{ ...ellipsisStyle, backgroundColor: props.color ?? "white" }}
        variants={variants}
        initial="start"
        animate="end"
        transition={{
          ...transitionConfig,
          delay: 0.2,
        }}
      />
    </motion.div>
  );
}
